export default __webpack_public_path__ + "images/bathroom-heat-background.6064f059c04c74318d577cf09f1e9b07.png";